package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Represents an active lockpicking challenge sent to a specific player.
 */
@Serializable
data class ActiveLockpicking(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("target_participant_id")
    val targetParticipantId: String,

    @SerialName("lock_count")
    val lockCount: Int,

    @SerialName("time_limit_seconds")
    val timeLimitSeconds: Int?,

    @SerialName("show_lock_count")
    val showLockCount: Boolean,

    @SerialName("sound_enabled")
    val soundEnabled: Boolean,

    @SerialName("unlocked_count")
    val unlockedCount: Int,

    @SerialName("status")
    val status: LockpickingStatus,

    @SerialName("created_by")
    val createdBy: String,

    @SerialName("created_at")
    val createdAt: Instant
)
